import * as React from 'react';

function SvgUpload(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.275 7.143l-3.748 3.621a.75.75 0 11-1.042-1.078l5.018-4.85a.747.747 0 011.043-.001l5.025 4.85a.75.75 0 01-1.042 1.08L15.775 7.14v13.153a.75.75 0 11-1.5 0V7.143zM23 20.293a.75.75 0 011.5 0v3.832a.75.75 0 01-.75.75H6.25a.75.75 0 01-.75-.75v-3.831a.75.75 0 011.5 0v3.081h16v-3.081z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgUpload;
